/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editsave1Inputs */

const en_editsave1 = /** @type {(inputs: Editsave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save to library`)
};

const de_editsave1 = /** @type {(inputs: Editsave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Mediathek speichern`)
};

/**
* | output |
* | --- |
* | "Save to library" |
*
* @param {Editsave1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editsave1 = /** @type {((inputs?: Editsave1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editsave1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editsave1(inputs)
	return de_editsave1(inputs)
});
export { editsave1 as "editSave" }